module.exports = __webpack_public_path__ + "static/media/LABELLE LOGO COEUR.44349fb3.jpg";